import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class OnboardingSignupController extends Controller {
  static values = {
    isEmail: Boolean
  };

  connect() {
    // this.userInterest()
    this.languageCount();
    if ($(this.element).hasClass("sign-up-form")) {
      this.handleDisabledButton();

      this.contactFieldTimeout = setTimeout(() => {
        this.toggleContactField(this.isEmailValue);
      }, 0);
      document.addEventListener("animationstart", this.handleAutofill);
    }
  }


  disconnect() {
    clearTimeout(this.contactFieldTimeout);
    document.removeEventListener("animationstart", this.handleAutofill);
  }

  handleAutofill = (event) => {
    if (event.animationName === "onAutoFillStart") {
      event.target.focus();
    }
  };

  handleDisabledButton() {
    this.submitButton = this.element.querySelector(".submit_button");
  }

  toggleSubmitButton() {
    if (!this.submitButton) return;

    const requiredFields = [...this.element.querySelectorAll("[required]")];

    const allFilled = requiredFields.every(field => {
      if (field.disabled || field.closest(".d-none")) return true;
      if (field.type === "checkbox" || field.type === "radio") return field.checked;

      return field.value.trim() !== "" && field.validity.valid;
    });

    const phoneInput = this.element.querySelector(".phone-no:not(:disabled)");
    const phoneController = phoneInput && this.application.getControllerForElementAndIdentifier(phoneInput, "phone-number");
    const phoneValid = !phoneInput || Boolean(phoneController?.iti?.isValidNumber());

    this.submitButton.disabled = !allFilled || !phoneValid;
  }

  toggleContactField(isEmail) {
    // Persist the selected method in the DOM that Turbo restores on Back.
    this.isEmailValue = isEmail;
    $("#email,.phoneLink").toggleClass("d-none", !isEmail);
    $("#phone,.emailLink").toggleClass("d-none", isEmail);

    $("select.error, #user_email, #user_phone_no").removeClass("error");
    $(".email-field").prop("disabled", !isEmail);
    $(".phone-no, .country_code").prop("disabled", isEmail);
    if (isEmail) {
      const val = $(".email-field").val();
      $(".email-field").val("");
      $(".email-field").val(val);
    }
    this.toggleSubmitButton();
    setTimeout(() => {
      globalThis.skipBlurValidation = true;
    }, 0);
  }

  startSwitch() {
    globalThis.skipBlurValidation = true;
  }

  get_email_field() {
    this.toggleContactField(true);
  }

  get_phone_field() {
    this.toggleContactField(false);
  }

  check_user(e) {
    e.preventDefault();
    const name = String($("#user-name").val() || "").trim();
    $("#sign-in-link").attr("href", "#");
    if (this.timeout) clearTimeout(this.timeout);
    if (!name) {
      $(".name_error")
        .removeClass("d-none")
        .addClass("error")
        .html("Please enter email, username or phone number.");
      return;
    }

    this.toggleLoader(true);
    this.timeout = setTimeout(() => {
      fetch("/check_user", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]")?.content || "",
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          user_name: name
        })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.user) {
            $(".name_error").addClass("d-none").removeClass("error").html("");
            $(".name-submit").removeClass("disabled");
            const src = `/password/?user_name=${encodeURIComponent(name)}`;
            const modalFrame = document.getElementById("modal_content");

            if (modalFrame) {
              modalFrame.src = src;
            } else {
              Turbo.visit(src, { action: "advance" });
            }
          } else {
            $(".name_error")
              .removeClass("d-none")
              .addClass("error")
              .html("Sorry, we couldn't find your account.");
          }
        })
        .catch((error) => {
          this.toggleLoader(false);
        })
        .finally(() => {
          this.toggleLoader(false);
        });
    }, 1000);
  }

  toggleLoader(show = true) {
    const $element = $(this.element);

    $element.find(".btn-text").toggleClass("d-none", show);
    $element.find(".name-submit").toggleClass("disabled", show);
    $element.find("#loader").toggleClass("d-none", !show);
  }

  // userInterest() {
  //   let total = document.querySelectorAll('.checkbox-pink.interest')
  //   const checked = Array.from(total).filter((cb) => cb.checked).length
  //   let errorBox = document.getElementById('content_error')
  //   let submitButton = document.querySelector('.interest-button')
  //   if (!submitButton) {
  //     return
  //   }
  //   if (checked >= 3) {
  //     errorBox.innerHTML = ''
  //     submitButton.disabled = false
  //   } else if (checked > 0 && checked < 3) {
  //     errorBox.innerHTML = `<!--<p class="text-danger fs-18">Please select at least 3 interest.</p>-->`
  //     submitButton.disabled = true
  //   } else if (checked === 0) {
  //     errorBox.innerHTML = ''
  //     submitButton.disabled = true
  //   }
  // }

  userFollow() {
    $(this.element)
      .closest(".modal-body")
      .next("div")
      .find(".follow-button")
      .removeClass("disabled");
  }

  disableButton(e) {
    $("#content_error").find("p").html(" ");
    $(e.currentTarget).closest("form").find("button").prop("disabled", false);
  }

  languageCount(e = false) {
    if (!$(this.element).hasClass("language-form")) return;

    const checkboxes = document.querySelectorAll(".checkbox-pink.language");
    const checked = Array.from(checkboxes).filter((cb) => cb.checked).length;
    let errorBox = document.getElementById("content_error");
    let submitButton = document.querySelector(".language-btn");
    if (!submitButton) {
      return;
    }

    if (!e) return;

    if (checked > 5) {
      e.target.checked = false;
      errorBox.innerHTML = "<p class=\"text-danger fs-18\">You can select maximum 5 languages</p>";
    } else if (checked === 0) {
      errorBox.innerHTML = "";
      submitButton.disabled = true;
    } else {
      errorBox.innerHTML = "";
    }
  }

  removeError(e) {
    e.stopPropagation();
    $(".name_error").html("");
  }

  async confirmSignInDiscard(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;

    const input = this.element.querySelector("#user-name");
    if (!input?.value.trim()) return;

    event.preventDefault();
    if (this.signInDiscardPending) return;

    const destination = event.currentTarget.href;
    this.signInDiscardPending = true;
    try {
      const result = await Swal.fire({
        customClass: {
          popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
          htmlContainer: "text-black-paint text-white"
        },
        title: "Discard sign-in details?",
        text: "Your entered email, username or phone number will be discarded.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Discard",
        reverseButtons: true
      });
      if (result.isConfirmed) {
        Turbo.visit(destination);
      } else {
        input.focus();
      }
    } finally {
      this.signInDiscardPending = false;
    }
  }

  normalizeSignInIdentifier(e) {
    const input = e.currentTarget;
    const valueWithoutSpaces = input.value.replace(/\s/g, "");
    const maxLength = Number(input.dataset.validLength);

    if (input.value !== valueWithoutSpaces) {
      input.value = valueWithoutSpaces;
    }

    if (input.value.length > maxLength) {
      this.showError(`Character limit exceeded. Maximum allowed: ${maxLength} characters`);
      this.element.querySelector('.name-submit').classList.add('disabled');
      return;
    }

    this.removeError(e);
    this.element.querySelector('.name-submit').classList.remove('disabled');
  }

  showError(message) {
    $(".name_error").removeClass("d-none").addClass("error").html(message)
  }
}
